/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Photo_ChangeInputs */

const en_profile_photo_change = /** @type {(inputs: Profile_Photo_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change photo`)
};

const pt_br2_profile_photo_change = /** @type {(inputs: Profile_Photo_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterar foto`)
};

/**
* | output |
* | --- |
* | "Change photo" |
*
* @param {Profile_Photo_ChangeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const profile_photo_change = /** @type {((inputs?: Profile_Photo_ChangeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Photo_ChangeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_photo_change(inputs)
	return pt_br2_profile_photo_change(inputs)
});